export default __webpack_public_path__ + "static/montserrat-v14-latin-600-dc335c19dac161a128075709d52e70e5.eot";